import type {ReactElement} from 'react';
import React, { useEffect} from 'react';
import type { BaseStandardGridProps} from '@Components/base-standard-grid';
import {BaseStandardGrid} from '@Components/base-standard-grid';
import {useAppDispatch} from '@/hooks';
import {addGrid} from '../base-grid';
import type {GridItemStorage} from '../base-grid/components/grid-item';

export interface StandardGridProps extends BaseStandardGridProps {
  items?: Array<GridItemStorage>;
}

/**
 * This class creates a grid widget.
 *
 * This widget fires the following jQuery custom event (on its el_ property):
 * - 'grid:onSelectionUpdated' when the number of selected grid-items changes. The old count and the new count of selected grid-items is passed along with this event
 */
export function StandardGrid({items = [], ...props}: StandardGridProps): ReactElement {
  const dispatch = useAppDispatch();
  const selectionGroupId = props.gridSelectionGroupId ?? props.gridId;

  useEffect(() => {
    dispatch(
      addGrid({
        id: props.gridId,
        maxSelectionNumber: props.maxSelectionNumber,
        gridSelectionGroupId: selectionGroupId,
        items,
      })
    );
  }, []);

  return <BaseStandardGrid {...props} gridSelectionGroupId={selectionGroupId} />;
}
